import type { Audit } from '@app/shared/types/sf-data'
import type { ChangesSinceLastVisitAuditItem } from './types'

export function isChangesSinceLastVisitAuditItem(
  audit: Audit | ChangesSinceLastVisitAuditItem
): audit is ChangesSinceLastVisitAuditItem {
  return audit.kind === 'changes-since-last-visit-line'
}
